<!-- ----------------------------------------------- -->
<template>
  <div>
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 180 300"
      width="180"
      height="300"
    >
      <defs>
        <path d="M5 5L30 5L30 30L5 30L5 5Z" id="stageOver"></path>
        <path d="M5 35L30 35L30 60L5 60L5 35Z" id="stageDanger"></path>
        <path d="M5 65L30 65L30 90L5 90L5 65Z" id="stageRefuge"></path>
        <path d="M5 95L30 95L30 120L5 120L5 95Z" id="stageWarning"></path>
        <text id="stageOverText" x="40" y="24" font-size="0.9rem">
          {{ text.stageOver }}
        </text>
        <text id="stageDangerText" x="40" y="54" font-size="0.9rem">
          {{ text.stageDanger }}
        </text>
        <text id="stageRefugeText" x="40" y="84" font-size="0.9rem">
          {{ text.stageRefuge }}
        </text>
        <text id="stageWarningText" x="40" y="114" font-size="0.9rem">
          {{ text.stageWarning }}
        </text>
      </defs>
      <g>
        <g>
          <use
            xlink:href="#stageOver"
            opacity="1"
            fill-opacity="1"
            :fill="color.stageOver"
            stroke="#000000"
            stroke-width="3"
            stroke-opacity="1"
          ></use>
          <use
            xlink:href="#stageOverText"
            opacity="1"
            fill="#000000"
            fill-opacity="1"
          ></use>
        </g>
        <g>
          <use
            xlink:href="#stageDanger"
            opacity="1"
            fill-opacity="1"
            :fill="color.stageDanger"
            stroke="#000000"
            stroke-width="3"
            stroke-opacity="1"
          ></use>
          <use
            xlink:href="#stageDangerText"
            opacity="1"
            fill="#000000"
            fill-opacity="1"
          ></use>
        </g>
        <g>
          <use
            xlink:href="#stageRefuge"
            opacity="1"
            fill-opacity="1"
            :fill="color.stageRefuge"
            stroke="#000000"
            stroke-width="3"
            stroke-opacity="1"
          ></use>
          <use
            xlink:href="#stageRefugeText"
            opacity="1"
            fill="#000000"
            fill-opacity="1"
          ></use>
        </g>
        <g>
          <use
            xlink:href="#stageWarning"
            opacity="1"
            fill-opacity="1"
            :fill="color.stageWarning"
            stroke="#000000"
            stroke-width="3"
            stroke-opacity="1"
          ></use>
          <use
            xlink:href="#stageWarningText"
            opacity="1"
            fill="#000000"
            fill-opacity="1"
          ></use>
        </g>
      </g>
    </svg>
  </div>
</template>
<!-- ----------------------------------------------- -->
<script>
import Color from "../../../scss/color.scss";

/**
 * 川の防災情報 地図画面 地図凡例ダイアログ 洪水予報
 * LegendFldfr.vue
 * @author LIS
 */
export default {
  name: "legend-fldfr",
  data() {
    return {
      /** 色 */
      color: {
        stageOver: Color.rwStgOver,
        stageDanger: Color.rwStgDanger,
        stageRefuge: Color.rwStgRefuge,
        stageWarning: Color.rwStgWarn,
      },
      /** 文字列リソース */
      text: {
        stageOver: "氾濫発生情報",
        stageDanger: "氾濫危険情報",
        stageRefuge: "氾濫警戒情報",
        stageWarning: "氾濫注意情報",
      },
    };
  },
};
</script>
